import { render, staticRenderFns } from "./Coccydynia.vue?vue&type=template&id=60b39506&scoped=true"
import script from "./Coccydynia.vue?vue&type=script&lang=js"
export * from "./Coccydynia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b39506",
  null
  
)

export default component.exports